import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryEntry() {
  const featuredCats = categories.slice(0, 4);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">
          <div className="lg:w-[35%] space-y-5">
            <span className="inline-flex items-center gap-1.5 px-4 py-1.5 bg-accent-500/10 text-accent-400 text-xs font-medium rounded-full border border-accent-500/20">
              探索分类
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-foreground-50 leading-tight">
              发现你喜欢的
              <br />
              漫画类型
            </h2>
            <p className="text-sm text-foreground-400 leading-relaxed">
              从甜蜜浪漫到热血冒险，从悬疑惊悚到奇幻魔法 —— 六大分类，总有一款适合你的口味。每部漫画都经过精心筛选，确保为您带来最佳的阅读体验。
            </p>
            <Link
              to="/category/romance"
              className="inline-flex items-center gap-2 text-sm font-medium text-primary-400 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap"
            >
              浏览全部分类
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="lg:w-[65%] grid grid-cols-1 sm:grid-cols-2 gap-5">
            {featuredCats.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group relative rounded-2xl overflow-hidden border border-background-200/30 transition-all duration-300 hover:border-accent-500/20"
              >
                <div className="aspect-[16/9] relative overflow-hidden">
                  <img
                    src={cat.image}
                    alt={`${cat.name}韩漫分类`}
                    title={`${cat.name} - 韩漫在线阅读分类`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-950/70 via-background-950/10 to-transparent"></div>
                  <div className="absolute inset-0 bg-accent-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

                  <div className="absolute bottom-0 left-0 right-0 p-4">
                    <div className="flex items-center justify-between">
                      <p className="text-foreground-50 font-bold text-lg">{cat.name}</p>
                      <span className="text-xs text-foreground-400 bg-background-950/60 px-2.5 py-1 rounded-full">
                        {cat.count}部
                      </span>
                    </div>
                    <p className="text-foreground-400 text-xs mt-1 line-clamp-1">{cat.description}</p>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}